import script from "./FooterModel.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterModel.vue?vue&type=script&setup=true&lang=js"

import "./FooterModel.vue?vue&type=style&index=0&id=36fc7eda&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36fc7eda"]])

export default __exports__